import { useEffect,useState } from "react";
import { ref,onValue,update } from "firebase/database";
import { database } from "../firebase/firebase";
import AdminMenu from "../components/AdminMenu";

export default function UserList(){

const [users,setUsers] = useState({})

useEffect(()=>{

const userRef = ref(database,"system/users")

onValue(userRef,(snapshot)=>{

setUsers(snapshot.val() || {})

})

},[])

const toggleUser = (id,currentStatus)=>{

update(ref(database,"system/users/"+id),{
active: !currentStatus
})

}

return(

<div>

<AdminMenu/>

<div className="container">

<h2>User Management</h2>

{Object.keys(users).map((id)=>{

const user = users[id]

return(

<div className="card" key={id}>

<p>{user.username}</p>
<p>{user.email}</p>
<p>Status: {user.active ? "Active" : "Disabled"}</p>

<button
onClick={()=>toggleUser(id,user.active)}
>
{user.active ? "Disable" : "Enable"}
</button>

</div>

)

})}

</div>

</div>

)

}